import { call, put, takeLatest } from "redux-saga/effects";
import { getTraineeCountsApi } from "../../../../api/dashboard";
import { IBaseResponse } from "../../../../interfaces/base";
import { IFetchDashboardActiveUsersAction } from "../../../../interfaces/store/dashboard-interface";
import {
  getTraineeCountsStart,
  getTraineeCountsSuccess,
  getTraineeCountsFailed,
} from "./active-users-slice";

function* _getTraineeCounts({ payload }: IFetchDashboardActiveUsersAction) {
  try {
    const { trainerId, type, skip, limit } = payload;
    const response: IBaseResponse = yield call(
      getTraineeCountsApi,
      type,
      skip,
      limit,
      trainerId
    );

    if (response.error) {
      yield put(getTraineeCountsFailed(response.error));
    } else {
      yield put(
        getTraineeCountsSuccess({
          data: response.data,
        })
      );
    }
  } catch (error: any) {
    console.log("error:", error);
    yield put(getTraineeCountsFailed({ message: error.message }));
  }
}

function* dashboardActiveUsersSaga() {
  yield takeLatest(getTraineeCountsStart.type, _getTraineeCounts);
}

export default dashboardActiveUsersSaga;
